import { withInstall, withNoopInstall } from '@jdesign-vue/utils'

import Steps from './src/steps.vue'
import Step from './src/item.vue'

export const JdSteps = withInstall(Steps, {
  Step,
})
export default JdSteps
export const JdStep = withNoopInstall(Step)

export * from './src/item'
export * from './src/steps'
